import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';
import { useTranslation } from 'react-i18next';

interface InformationCardProps {
  user: GatewayUserModel;
}

export const InformationCard = ({
  user,
}: InformationCardProps): React.JSX.Element => {
  const { t } = useTranslation();
  return (
    <Card flex={1} gap={GapEnum.M}>
      <AccentTitle
        icon="info-circle"
        as={HeadingEnum.H2}
        text={t('$.user-details.information')}
      />
      <Stack justifyContent="space-between">
        <Text bold>
          <Icon name="phone-call-01" />
          {t('delmonicos-shared-sdk.outputs-user.landline-number')}
        </Text>
        <Text>{user.landlineNumber ?? '-'}</Text>
      </Stack>
      <Stack justifyContent="space-between">
        <Text bold>
          <Icon name="phone-01" />
          {t('delmonicos-shared-sdk.outputs-user.mobile-number')}
        </Text>
        <Text>{user.mobileNumber ?? '-'}</Text>
      </Stack>
      <Stack justifyContent="space-between">
        <Text bold>
          <Icon name="mail-01" />
          {t('delmonicos-shared-sdk.outputs-user.email-address')}
        </Text>
        <Text>{user.emailAddress ?? '-'}</Text>
      </Stack>
    </Card>
  );
};
